import { FC } from 'react'
import { ClinicalProps } from './Clinical.types'
import { YogaResults } from 'components/Clinical/YogaResults'
import { WeKnowALot } from 'components/Clinical/WeKnowALot'
import { PeerReviewedFindings } from 'components/Clinical/PeerReviewedFindings'
import { NoWearableNeeded } from 'components/Clinical/NoWearableNeeded'
import { IndustryLeaders } from 'components/Phantom/_sections/IndustryLeaders'
import { TwelveWeeks } from 'components/Clinical/TwelveWeeks'
import { ThePodVersusOtherSleepAids } from 'components/Clinical/ThePodVersusOtherSleepAids'
import { GoldStandardTrackingSlider } from 'components/Clinical/GoldStandardTrackingSlider'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import { Pod4HeroClinical } from 'components/Phantom/_sections/Pod4Hero'

export const Clinical: FC<ClinicalProps> = (props) => {
	const {} = props
	return (
		<main>
			<Pod4HeroClinical />
			<YogaResults />
			<WeKnowALot />
			<PeerReviewedFindings />
			<NoWearableNeeded />
			<IndustryLeaders cta={{ href: '/blog/welcoming-new-scientific-advisory-board', text: 'Meet the board' }} />
			<TwelveWeeks />
			<ThePodVersusOtherSleepAids />
			<GoldStandardTrackingSlider />
			<ScrollSequenceStatic />
		</main>
	)
}
